import { render, staticRenderFns } from "./SpamMxForm.vue?vue&type=template&id=12d03c0a&scoped=true"
import script from "./SpamMxForm.vue?vue&type=script&lang=js"
export * from "./SpamMxForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d03c0a",
  null
  
)

export default component.exports